import classNames from 'classnames';
import * as React from 'react';

import { Bem } from '../../../service/Bem/Bem';
import { Omit } from '../../../typings/utils';
import { SuggestDecorator, SuggestDecoratorProps } from '../../SuggestDecorator/SuggestDecorator';

import './TagSuggestDecorator.css';

const BLOCK = 'tag-input-decorator';

export type TagSuggestDecoratorProps = Omit<SuggestDecoratorProps, 'size' | 'theme' | 'view' | 'autofocus'>;

export const TagSuggestDecorator: React.FC<TagSuggestDecoratorProps> = React.memo(props => {
    const { cls, ...suggestProps } = props;

    return (
        <SuggestDecorator
            cls={classNames(cls, Bem.cls(BLOCK))}
            size={'xs'}
            theme={'normal'}
            view={'default'}
            autoFocus={true}
            sizeByContent={true}
            {...suggestProps}
        />
    );
});
